import React, { useRef } from "react";
import { Carousel, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faWifi,
  faFan,
  faSuitcaseRolling,
  faBottleWater,
  faCoffee,
  faUserGroup,
  faUserSecret,
  faChair,
  faRotateLeft,
  faBinoculars,
  faComment,
  faClock,
  faCrown,
  faSoap,
  faHandshake,
  faChampagneGlasses,
  faBurger,
  faCar,
} from "@fortawesome/free-solid-svg-icons";

import tesla from "../images/tesla.png";
import deplacementPro from "../images/DeplacementPro.png";
import luxe from "../images/Evenementsluxe.png";
import loisirs from "../images/Sortiesloisirs.png";
import tours from "../images/ToursPrives.png";
import aeroport from "../images/TransfertAeroport.png";
import { useNavigate } from "react-router-dom";
export default function VehicleCarousel() {
  const carouselRef = useRef(null);
  const navigate = useNavigate();
  const slides = [
    {
      category: "Aéroport",
      title: "Transferts Aéroport",
      subtitle: "Prise en charge terminal – suivi des vols – bagages inclus",
      img: aeroport,
      specs: [
        { label: "WiFi", icon: faWifi },
        { label: "Climatisation", icon: faFan },
        { label: "2-3 bagages", icon: faSuitcaseRolling },
        { label: "Eau", icon: faBottleWater },
        { label: "Café", icon: faCoffee },
      ],
    },
    {
      category: "Business",
      title: "Déplacements Professionnels",
      subtitle: "Ponctualité – discrétion – productivité",
      img: deplacementPro,
      specs: [
        { label: "WiFi", icon: faWifi },
        { label: "3 passagers", icon: faUserGroup },
        { label: "Climatisation", icon: faFan },
        { label: "Eau", icon: faBottleWater },
        { label: "Café", icon: faCoffee },
      ],
    },
    {
      category: "Loisirs",
      title: "Sorties & Loisirs",
      subtitle: "Restaurants, soirées, événements privés",
      img: loisirs,
      specs: [
        { label: "Discrétion", icon: faUserSecret },
        { label: "Confort", icon: faChair },
        { label: "Retour Garantie", icon: faRotateLeft },
        { label: "Eau", icon: faBottleWater },
        { label: "Snacks", icon: faBurger },
      ],
    },
    {
      category: "Tourisme",
      title: "Tour Privés & Découvertes",
      subtitle: "Exploration de la Côte d’Azur avec chauffeur privé",
      img: tours,
      specs: [
        { label: "Arrêts panoramiques", icon: faBinoculars },
        { label: "Guide chauffeur", icon: faComment },
        { label: "4 heures mini", icon: faClock },
        { label: "Eau", icon: faBottleWater },
        { label: "Snacks", icon: faBurger },
      ],
    },
    {
      category: "Événements",
      title: "Événements & Luxe",
      subtitle: "Mariages – galas – casinos – VIP – Cannes",
      img: luxe,
      specs: [
        { label: "Service premium", icon: faCrown },
        { label: "Voiture propre", icon: faSoap },
        { label: "Accueil soigné", icon: faHandshake },
        { label: "Champagne", icon: faChampagneGlasses },
        { label: "Eau", icon: faBottleWater },
      ],
    },
  ];

  // Swipe mobile natif
  let touchStartX = 0;

  const handleTouchStart = (e) => {
    touchStartX = e.changedTouches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const deltaX = e.changedTouches[0].clientX - touchStartX;
    const carouselNode = carouselRef.current;

    if (!carouselNode) return;

    if (deltaX > 50) {
      carouselNode.prev();
    } else if (deltaX < -50) {
      carouselNode.next();
    }
  };

  return (
    <section className="svc-fullscreen">
      <Carousel
        ref={carouselRef}
        controls={true}
        indicators={true}
        fade
        interval={6500}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        {slides.map((s, idx) => (
          <Carousel.Item key={idx}>
            <img className="svc-bg-img" src={s.img} alt={s.title} />

            <div className="svc-center-overlay">
              <div className="svc-bubble">
                <h2 className="svc-title">{s.title}</h2>
                <p className="svc-subtitle">{s.subtitle}</p>

                <div className="svc-specs">
                  {s.specs.map((spec, i) => (
                    <div className="svc-spec-item" key={i}>
                      <FontAwesomeIcon icon={spec.icon} />
                      <span>{spec.label}</span>
                    </div>
                  ))}
                </div>

                <Button
                  className="btn-primary-gold mt-3"
                  onClick={() => navigate("/réserver")}
                >
                  <FontAwesomeIcon icon={faCar} className="me-2" /> Réserver
                </Button>
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </section>
  );
}
